import { useEffect, useMemo, useState } from "react";
import Select from "react-select";

export const SelectComponent = ({
  isFetching,
  mainItems,
  selectedItems,
  setSelectedItems,
  defaultSelected,
}) => {
  // State to hold the default items
  // This is used to reset the selection when "Select All" is clicked
  const [defaultItems, setDefaultItems] = useState([]);

  // Ensure defaultSelected is an array
  defaultSelected = Array.isArray(defaultSelected) ? defaultSelected : [];

  // Ensure mainItems is an array
  mainItems = Array.isArray(mainItems) ? mainItems : [];

  // Ensure selectedItems is an array
  selectedItems = Array.isArray(selectedItems) ? selectedItems : [];

  useEffect(() => {
    setDefaultItems(defaultSelected);
  }, [defaultSelected]);

  const allOptions = useMemo(
    () => [{ value: "*", label: "Select All" }, ...mainItems],
    [mainItems]
  );

  const isAllSelected = selectedItems.length === mainItems.length;

  const handleChange = (selected) => {
    if (!selected) return setSelectedItems([]);

    const lastSelected = selected[selected?.length - 1];

    if (lastSelected?.value === "*") {
      setSelectedItems(isAllSelected ? defaultItems : mainItems);
    } else {
      const values = selected.filter((opt) => opt.value !== "*");
      setSelectedItems(values);
      setDefaultItems(values);
    }
  };

  return (
    <Select
      isLoading={isFetching || false}
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
      menuPortalTarget={document.body}
      isMulti
      isSearchable={true}
      options={allOptions}
      value={selectedItems}
      onChange={handleChange}
      closeMenuOnSelect={false}
    />
  );
};
